var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mainBox app-wrapper dream" },
    [
      _c("childNav", {
        attrs: { routerName: _vm.$t("audio.title"), backFlag: true },
      }),
      _c(
        "div",
        { staticClass: "app-content config-body" },
        [
          _c(
            "Row",
            { staticClass: "full-box", attrs: { gutter: "20" } },
            [
              _c(
                "i-col",
                { attrs: { span: "12", offset: "6" } },
                [
                  _c(
                    "Form",
                    {
                      ref: "project",
                      attrs: { "label-width": 150, "label-colon": "" },
                    },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: { prop: "name", label: _vm.$t("audio.lock") },
                        },
                        [
                          _c("inputBox", {
                            attrs: { "input-id": "lockId", index: 0 },
                            on: { getBinaryData: _vm.getBinaryData },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            prop: "description",
                            label: _vm.$t("audio.call"),
                          },
                        },
                        [
                          _c("inputBox", {
                            attrs: { "input-id": "callId", index: 1 },
                            on: { getBinaryData: _vm.getBinaryData },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            prop: "areaCodeNum",
                            label: _vm.$t("audio.speak"),
                          },
                        },
                        [
                          _c("inputBox", {
                            attrs: { "input-id": "speakId", index: 2 },
                            on: { getBinaryData: _vm.getBinaryData },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "FormItem",
                        {
                          attrs: { prop: "name", label: _vm.$t("audio.busy") },
                        },
                        [
                          _c("inputBox", {
                            attrs: { "input-id": "busyId", index: 3 },
                            on: { getBinaryData: _vm.getBinaryData },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex-box center-box" },
                    [
                      _c(
                        "Button",
                        {
                          staticClass: "footer-btn",
                          attrs: { type: "primary", ghost: "", size: "large" },
                          on: { click: _vm.setNewWindow },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("common.reset")) + " ")]
                      ),
                      _c(
                        "Button",
                        {
                          staticClass: "footer-btn",
                          attrs: { type: "primary", size: "large" },
                          on: { click: _vm.createFile },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("audio.add")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }